import { FC, ReactNode } from 'react';
import { Button, Modal, Typography } from 'antd';
import { Col, Row } from '../layout';

const { Title } = Typography;

type Props = {
  open: boolean;
  title: string | ReactNode;
  text: string | ReactNode;
  confirmBtnText?: string;
  cancelBtnText?: string;
  loading?: boolean;
  dataTestid?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmModal: FC<Props> = ({
  open,
  confirmBtnText = 'Confirm',
  cancelBtnText = 'Cancel',
  loading = false,
  onConfirm,
  onCancel,
  title,
  text,
  dataTestid = 'confirm-modal',
}) => {
  return (
    <Modal
      data-testid={dataTestid}
      title={
        <Col
          alignItems="flex-start"
          style={{ margin: '10px 0', width: '100%' }}
        >
          <Title level={4} style={{ lineHeight: 1, marginTop: 15 }}>
            {title}
          </Title>
        </Col>
      }
      width={350}
      open={open}
      footer={null}
      style={{ maxWidth: '90%' }}
      onCancel={onCancel}
    >
      <>
        <div style={{ marginTop: 20 }}>{text}</div>
      </>
      <Row>
        <Button
          onClick={onCancel}
          style={{ width: '40%', height: 40, marginTop: 30 }}
        >
          {cancelBtnText}
        </Button>
        <Button
          danger
          type="primary"
          loading={loading}
          onClick={onConfirm}
          style={{ width: '60%', height: 40, marginTop: 30 }}
        >
          {confirmBtnText}
        </Button>
      </Row>
    </Modal>
  );
};
